export type HistoryUpdateMode = 'push' | 'replace'

export function readQueryParam(paramName: string): string | null {
	const queryParams = new URLSearchParams(window.location.search)
	const value = queryParams.get(paramName)
	return value !== null ? decodeURIComponent(value) : null
}

export function applyQueryParamUpdate(currentSearch: string, paramName: string, value: string | null): string {
	const queryParams = new URLSearchParams(currentSearch)

	if (!value) {
		queryParams.delete(paramName)
	} else {
		queryParams.set(paramName, value)
	}

	return queryParams.toString()
}

export function setQueryParam(paramName: string, value: string | null, mode: HistoryUpdateMode = 'push'): void {
	const search = applyQueryParamUpdate(window.location.search, paramName, value)
	const newURL = search ? `${window.location.pathname}?${search}` : window.location.pathname

	if (mode === 'replace') {
		window.history.replaceState(null, '', newURL)
	} else {
		window.history.pushState(null, '', newURL)
	}
}
